import Router from '../Router';
import { PreseasonController } from '../../controllers';
import { Secret } from '../../utils';

const
	IS_PRE_SEASON = Secret.is_passed ? false : JSON.parse(process.env.IS_PRE_SEASON),
	preventAnyOtherPages = IS_PRE_SEASON ? { '*any': 'redirectToHomePage' } : null;

export default class PreseasonRouter extends Router {
	constructor(args) {
		super(args);

		/**
		 * All routes doesn't required for auth
		 * @type {boolean}
		 */
		this.authOnlyDefault = false;
	}

	initialize(options) {
		this.controller = new PreseasonController(options);
	}

	get appRoutes() {
		return {
			'(/)': 'preseason',
			'rankings/tipping': 'rankingsTipping',
			'help/prizes': 'prizes',
			...preventAnyOtherPages
		};
	}
}